import { useCallback, useMemo, useState } from 'react';
import Link from './link';
import Header from './header';
import UptimeRobot from './uptimerobot';
import Package from '../../package.json';

function App() {

  const apiTokens = useMemo(() => {
    const tokens = window.Config.ApiTokens || window.Config.ApiKeys;
    if (Array.isArray(tokens)) return tokens;
    if (typeof tokens === 'string') return [tokens];
    return [];
  }, []);

  const [groups, setGroups] = useState({});

  const handleChange = useCallback((token, data) => {
    setGroups((previous) => ({ ...previous, [token]: data }));
  }, []);

  const summary = useMemo(() => {
    if (!apiTokens.length) return null;

    const loaded = apiTokens.map((token) => groups[token]).filter(Boolean);
    const monitors = loaded.flatMap((group) => group.monitors || []);
    const failed = loaded.some((group) => group.error);
    const down = monitors.filter((monitor) => monitor.status === 'down');

    if (!monitors.length) {
      return failed
        ? { state: 'warn', title: '状态数据加载失败', detail: '请检查 config.js 中的 ApiTokens 配置，或稍后刷新重试' }
        : { state: 'loading', title: '正在获取最新状态…', detail: '首次加载需要几秒钟' };
    }

    if (down.length) {
      const names = down
        .map((monitor) => String(monitor.name).replace(/<[^>]*>/g, ''))
        .join('、');
      return { state: 'down', title: `${down.length} 个服务出现故障`, detail: names };
    }

    if (failed) {
      return { state: 'warn', title: '部分监控数据加载失败', detail: `其余 ${monitors.length} 个服务运行正常，刷新页面可重试` };
    }

    return { state: 'ok', title: '所有系统运行正常', detail: `正在监控 ${monitors.length} 个服务 · 每 5 分钟自动更新` };
  }, [apiTokens, groups]);

  return (
    <>
      <Header />
      <div className='container'>
        {summary && (
          <div id='summary' className={summary.state}>
            <span className='badge' />
            <div className='text'>
              <h2>{summary.title}</h2>
              {summary.detail && <p>{summary.detail}</p>}
            </div>
          </div>
        )}
        <div id='uptime'>
          {apiTokens.length
            ? apiTokens.map((token) => (
              <UptimeRobot key={token} apiToken={token} onChange={(data) => handleChange(token, data)} />
            ))
            : <div className='item error'>请在 config.js 中配置 ApiTokens</div>}
        </div>
        <div id='footer'>
          <p>基于 <Link to='https://uptimerobot.com/' text='UptimeRobot' /> 接口制作，检测频率 5 分钟</p>
          <p>&copy; 2020 <Link to='https://status.xinai.de/' text='status.xinai.de' />, Version {Package.version}</p>
        </div>
      </div>
    </>
  );
}

export default App;
